// Strings shared by both apps (errors, generic actions, states).
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// Strings that already exist in the prototype catalog (en.ts) need no entry here.
export const commonEn: Readonly<Record<string, string>> = {};
